export function getLastArrayElement<T>(subject: T[]): T | undefined {
  return subject[subject.length - 1];
}
